<template>
    <div>
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="banner" v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/air-banner.jpg)'}">

        </div>
        <div class="main">
            <h3 class="app-title">机场接送</h3>
            <p class="app-title-p"><i class="app-i app-i-left"></i>正确打开英伦之旅 完美结束留学生涯<i class="app-i app-i-right"></i></p>
            <ul class="main-top  content-container">
                <li>
                    <img :src="air_img1" />
                    <h3>迟到赔付</h3>
                    <p>司机迟到一经核实，我们将根据客人等待时长赔付相应金额的优惠券。</p>
                </li>
                <li>
                    <img :src="air_img2" />
                    <h3>爽约退赔</h3>
                    <p>如果客人到场后联系不上司机，可以在第一时间通过电话、在线联系客服。我们将立刻为客人协调，如最终未能提供服务，我们将为客人提供赔款。</p>
                </li>
                <li>
                    <img :src="air_img3" />
                    <h3>确认保障</h3>
                    <p>服务商确认接单后再取消订单，导致客人无法出行，我们为客人办理全额退款。</p>
                </li>
                <li>
                    <img :src="air_img4" />
                    <h3>取消保证</h3>
                    <p>如果航班取消，用车订单可以取消。</p>
                </li>
            </ul>
            <div class="main-bottom">
                 <p class="app-title-p"><i class="app-i app-i-left"></i>全程保障  确保客户完美体验<i class="app-i app-i-right"></i></p>
                <ul class="content-container">
                    <li><span class="number">01</span>微信咨询<span class="dian"></span><span class="line"></span></li>
                    <li><span class="number">02</span>确认航班<span class="dian"></span><span class="line"></span></li>
                    <li><span class="number">03</span>确认地址<span class="dian"></span><span class="line"></span></li>
                    <li><span class="number">04</span>完成接送</li>
                </ul>
            </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import air_img1 from '@assets/image/manage/air-img1.png'
import air_img2 from '@assets/image/manage/air-img2.png'
import air_img3 from '@assets/image/manage/air-img3.png'
import air_img4 from '@assets/image/manage/air-img4.png'
export default {
    name: 'PickUpPage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            air_img1,air_img2,air_img3,air_img4

        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.main{
    padding-top:5rem;
    text-align: center;   
}
.main-top{
    display: flex;
    justify-content:space-between;
    margin:2.5rem auto;
    h3{
        color: $color;
        line-height: 4rem;
        font-size: 1.5rem;
    }
    p{
        color: #3a4a5b;
        font-size: 0.8rem;
        text-align: left;
        line-height: 28px;
    }
    li{
        width: 12.5rem;
        img{
            width: 3.4rem;
            height: 3.9rem;
        }
    }
}
.main-bottom{
    width: 100%;
    height: 13.8rem;
    background: #f7f7f7;
    padding-top:0.5rem;
    ul{
        display: flex;
        padding-left: 2rem;
        justify-content:space-around;
        li{
            font-size: 1.4rem;
            color: $color;
            font-weight: 700;
            margin-top:3rem;
            position: relative;
            span{
                color: #dedfe1;
                font-size: 2.8rem;
            }
            .number{
                position:absolute;
                top:-1.8rem;
                left: -3.3rem;
            }
        }
        .dian{
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #b21800;
            margin-left: 1rem;
        }
        .line{
            display: inline-block;
            width: 4.5rem;
            border-top:2px dashed #a22915;
            margin-bottom: 2px;
            margin-left: 6px;
        }
    }
}
</style>